import { LinkType } from '@easeltv/analytics';
import { MenuLink } from '@easeltv/client-sdk';

import { useScrollWrapper } from '../../../hooks/useScrollWrapper/useScrollWrapper';
import LinkAtom from '../../Atoms/LinkAtom';
import { getDestination } from '../../Atoms/LinkAtom/LinkAtom.helpers';
import {
    MenuBlockWrapper,
    MenuNavButton,
    StyledMenuBlock,
} from './MenuBlock.styled';

/* ---------------------------------- Types --------------------------------- */

export interface MenuBlockDumbProps {
    /** Menu items to display */
    items: MenuLink[];

    /** Callback to track menu link clicks */
    trackMenuLinkClicked: (destination: LinkType) => void;
}

/* -------------------------------- Component ------------------------------- */

const DumbMenuBlock = ({ items, trackMenuLinkClicked }: MenuBlockDumbProps) => {
    const { wrapperRef, showScrollBack, showScrollForward, scrollWrapper } =
        useScrollWrapper<HTMLDivElement>([items]);

    // Return the component
    return (
        <StyledMenuBlock>
            {showScrollBack && (
                <MenuNavButton onClick={scrollWrapper(false)}>
                    <i
                        className="fa fa-chevron-left"
                        data-testid="arrow-left"
                    />
                </MenuNavButton>
            )}
            <MenuBlockWrapper ref={wrapperRef}>
                {items.length > 1 &&
                    items.map((item) => (
                        <LinkAtom
                            key={item.id}
                            data={item}
                            section="header"
                            callback={() => {
                                trackMenuLinkClicked(getDestination(item));
                            }}
                        />
                    ))}
            </MenuBlockWrapper>
            {showScrollForward && (
                <MenuNavButton left={false} onClick={scrollWrapper()}>
                    <i
                        className="fa fa-chevron-right"
                        data-testid="arrow-right"
                    />
                </MenuNavButton>
            )}
        </StyledMenuBlock>
    );
};

/* --------------------------------- Export --------------------------------- */

export default DumbMenuBlock;
